<template>
  <section class="header-item-stats">
    <div v-if="node.imageUrl" class="item-stats-main-image gradient"> <!-- TODO: detect whitish border -->
      <img width="120" height="120" :src="node.imageUrl" :alt="node.name">
    </div>
    <div v-else class="item-stats-top-nodes-container no-image-block"></div>
    <div class="item-stats-top-nodes-container">
      <div class="item-stats-node-name robotoC">
        <a :href="nodeUrl" target="_blank">{{ node.name }}</a>
      </div>
      <div class="item-stats-metadata robotoR">{{ node.metadata }}</div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NodeHeader',
  props: {
    node: {
      type: Object,
      required: true
    }
  },
  computed: {
    nodeUrl() {
      return this.node ? `${process.env.RANKER_DOMAIN}/review/${this.node.urlFriendlyName}/${this.node.id}` : '';
    }
  }
};
</script>

<style lang="postcss">
.header-item-stats {
  height: 121px;
  width: 100%;
  border: solid 1px #dadada;
  background-color: #fcfcfc;

  .item-stats-main-image {
    width: 120px;
    height: 120px;
    margin-right: 19px;
    display: block;
    position: relative;

    img {
      width: 120px;
      height: 120px;
      display: inline-block;
    }

    &.gradient {
      width: 120px;
      height: 120px;
      z-index: 10;
      float: left;
      /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#ffffff+0,ffffff+100&amp;0+0,0.5+40,0.9+80,1+100 */
      background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0.9) 80%, rgba(255, 255, 255, 1) 100%); /* W3C */
      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff', endColorstr='#ffffff', GradientType=1); /* IE6-9 */
      /*background: -webkit-radial-gradient(top center, ellipse cover, rgba(255, 255, 255, 0.2) 0%, rgba(0, 0, 0, 0.5) 100%);*/

      &:before {
        display: block;
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        box-shadow: inset -95px 0 52px -64px rgba(255, 255, 255, 1);
      }
    }
  }

  .item-stats-top-nodes-container {
    width: 576px;
    height: 120px;
    float: left;
    margin-right: -20px;

    a {
      text-decoration: none !important;
      outline: none;
    }

    &.no-image-block {
      margin-left: 55px;
      width: 798px;

      .item-stats-node-name {
        margin-top: 18px;
      }
    }
  }

  .item-stats-metadata {
    @extend %robotoR;
    padding-left: 3px;
    font-size: 13px;
    color: #949090;
    /*text-overflow: ellipsis;*/
    overflow: hidden;
  }

  .item-stats-node-name {
    color: black;
    width: 590px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    letter-spacing: -2px;
    font-size: 45px;
    margin-top: 0;
  }
}
</style>